import { createAction, props } from '@ngrx/store'
import { LoginFormValues } from './login.state'

export enum LoginTypes {
  LOGIN = '[Login] Attempt Login',
  LOGIN_SUCCESS = '[Login] Login Successful',
  LOGIN_FAILED = '[Login] Login Failed',
}

export const LoginActions = {
  login: createAction(LoginTypes.LOGIN, props<{ payload: LoginFormValues }>()),
  loginSuccess: createAction(LoginTypes.LOGIN_SUCCESS),
  loginFailed: createAction(LoginTypes.LOGIN_FAILED),
} as const
